// Configuration des matériaux avec leurs shaders
// Externalisation des définitions de matériaux depuis MaterialManager

export const ScreenSpaceMaterialConfig = {
  uniforms: {
    map: null,
    uResolution: null,
    useColorCorrection: null
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    precision mediump float;
    uniform sampler2D map;
    uniform vec2 uResolution;
    uniform float useColorCorrection;
    varying vec2 vUv;
    
    // Fonction pour convertir de linear à sRGB
    vec3 linearToSRGB(vec3 color) {
      return mix(
        pow(color, vec3(1.0 / 2.2)),
        color * 12.92,
        step(color, vec3(0.0031308))
      );
    }
    
    // Fonction pour convertir de sRGB à linear
    vec3 sRGBToLinear(vec3 color) {
      return mix(
        pow(color, vec3(2.2)),
        color / 12.92,
        step(color, vec3(0.04045))
      );
    }
    
    void main() {
      vec2 screenUV = gl_FragCoord.xy / uResolution;
      vec4 textureColor = texture2D(map, screenUV);
      
      // Appliquer la correction colorimétrique proportionnellement
      vec3 correctedColor = sRGBToLinear(textureColor.rgb);
      textureColor.rgb = mix(textureColor.rgb, correctedColor, useColorCorrection);
      
      gl_FragColor = textureColor;
    }
  `
};

export const SegmentationMaterialConfig = {
  uniforms: {
    map: null,
    alphaMap: null,
    uResolution: null,
    minThreshold: 0.55,
    maxThreshold: 0.6,
    useColorCorrection: null
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    precision mediump float;
    uniform sampler2D map;
    uniform sampler2D alphaMap;
    uniform vec2 uResolution;
    uniform float minThreshold;
    uniform float maxThreshold;
    uniform float useColorCorrection;
    varying vec2 vUv;
    // Fonction pour convertir de linear à sRGB
    vec3 linearToSRGB(vec3 color) {
      return mix(
        pow(color, vec3(1.0 / 2.2)),
        color * 12.92,
        step(color, vec3(0.0031308))
      );
    }
    // Fonction pour convertir de sRGB à linear
    vec3 sRGBToLinear(vec3 color) {
      return mix(
        pow(color, vec3(2.2)),
        color / 12.92,
        step(color, vec3(0.04045))
      );
    }
    void main() {
      vec2 screenUV = gl_FragCoord.xy / uResolution;
      float maskValue = texture2D(alphaMap, screenUV).r;
      float smoothedMask = smoothstep(minThreshold, maxThreshold, maskValue);
      vec4 imageColor = texture2D(map, screenUV);
      vec3 correctedColor = sRGBToLinear(imageColor.rgb);
      imageColor.rgb = mix(imageColor.rgb, correctedColor, useColorCorrection);
      gl_FragColor = mix(vec4(0.0, 0.0, 0.0, 0.0), imageColor, smoothedMask);
    }
  `,
  options: {
    transparent: true
  }
};

export const CutoutSegmentationMaterialConfig = {
  uniforms: {
    map: null,
    alphaMap: null,
    uResolution: null,
    threshold: 0.5,
    useColorCorrection: null
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    precision mediump float;
    uniform sampler2D map;
    uniform sampler2D alphaMap;
    uniform vec2 uResolution;
    uniform float threshold;
    uniform float useColorCorrection;
    varying vec2 vUv;
    // Fonction pour convertir de sRGB à linear
    vec3 sRGBToLinear(vec3 color) {
      return mix(
        pow(color, vec3(2.2)),
        color / 12.92,
        step(color, vec3(0.04045))
      );
    }
    void main() {
      vec2 screenUV = gl_FragCoord.xy / uResolution;
      float maskValue = texture2D(alphaMap, screenUV).r;
      if (maskValue < threshold) discard;
      vec4 imageColor = texture2D(map, screenUV);
      vec3 correctedColor = sRGBToLinear(imageColor.rgb);
      imageColor.rgb = mix(imageColor.rgb, correctedColor, useColorCorrection);
      gl_FragColor = vec4(imageColor.rgb, 1.0);
    }
  `,
  options: {
    transparent: false,
    alphaTest: 0.5,
    depthWrite: true,
    depthTest: true
  }
};